
import { RouteObject } from 'react-router-dom';
import Home from '../pages/home/page';
import About from '../pages/about/page';
import CostCategories from '../pages/cost-categories/page';
import HowItWorks from '../pages/how-it-works/page';
import SuccessStories from '../pages/success-stories/page';
import Contact from '../pages/contact/page';
import SaasSoftware from '../pages/saas-software/page';
import InfrastructureCloud from '../pages/infrastructure-cloud/page';
import MarketingAdvertising from '../pages/marketing-advertising/page';
import VendorContracts from '../pages/vendor-contracts/page';
import PrivacyPolicy from '../pages/privacy-policy/page';
import TermsOfService from '../pages/terms-of-service/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '/cost-categories',
    element: <CostCategories />,
  },
  {
    path: '/how-it-works',
    element: <HowItWorks />,
  },
  {
    path: '/success-stories',
    element: <SuccessStories />,
  },
  {
    path: '/contact',
    element: <Contact />,
  },
  {
    path: '/saas-software',
    element: <SaasSoftware />,
  },
  {
    path: '/infrastructure-cloud',
    element: <InfrastructureCloud />,
  },
  {
    path: '/marketing-advertising',
    element: <MarketingAdvertising />,
  },
  {
    path: '/vendor-contracts',
    element: <VendorContracts />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicy />,
  },
  {
    path: '/terms-of-service',
    element: <TermsOfService />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
